import React, { useRef, useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ActionSection,
    ScrollableContent,
    MobileIcon,
    RupeeIcon,
    CombineInputGroup,
} from "../Styles/InputStyles";
import { MdClose, MdEdit } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { FaRegCalendar } from "react-icons/fa";
import SelectOptionModal from "../SelectOptionModal";
import { ProfileSection } from "../Styles/PageStyles";
import { FaRegBuilding } from "react-icons/fa";
import moment from "moment";

const AddTenant = ({ handleClose, key, selectedData, addTenantMutate, addTenantLoading }) => {
    let formikRef = useRef(null);
    const [height, setHeight] = useState(window.innerHeight);
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);

    useEffect(() => {
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
        const handleResize = () => setHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, [key]);

    const rentScheduleOptions = [
        { value: "01", label: "1st to 1st" },
        { value: "15", label: "15th to 15th" },
        { value: "MOVE_IN", label: "Move-In Date" },
    ];

    const initialValues = {
        tenant_name: "",
        mobile: "",
        tenant_email: "",
        rentSchedule: "",
        nextDueDate: null,
        monthlyRent: "",
        ownerPayout: "",
        margin: "",
        securityDeposit: "",
        agreementPeriod: "",
    };

    const validationSchema = Yup.object({
        tenant_name: Yup.string()
            .required("Tenant name is required")
            .min(3, "Minimum 3 characters required"),
        mobile: Yup.string()
            .required("Mobile number is required")
            .matches(/^[0-9]{10}$/, "Mobile must be 10 digits"),
        tenant_email: Yup.string().email("Invalid email").nullable(),
        // rentSchedule: Yup.string().required("Rent schedule is required"),
        nextDueDate: Yup.date().required("Next due date required"),
        monthlyRent: Yup.number().required("Monthly rent required"),
        ownerPayout: Yup.number()
            .required("Owner rent is required"),
        margin: Yup.number()
            .nullable(),
        securityDeposit: Yup.number().required("Security deposit required"),
        agreementPeriod: Yup.number().required("Agreement period required"),
    });
    const handleSubmit = (values) => {
        const payload = {
            inventoryId: selectedData.id,
            name: values.tenant_name,
            mobile: values.mobile,
            email: values.tenant_email || null,
            rentalCycle: values.nextDueDate
                ? moment(values.nextDueDate).format("DD")
                : null,
            moveInDate: values.nextDueDate
                ? moment(values.nextDueDate).format("YYYY-MM-DD")
                : null,
            agreementStartDate: values.nextDueDate
                ? moment(values.nextDueDate).format("YYYY-MM-DD")
                : null,
            monthlyRent: values.monthlyRent,
            ownerPayout: values.ownerPayout,
            margin:
                (values.monthlyRent || 0) - (values.ownerPayout || 0),

            securityDeposit: values.securityDeposit,
            agreementPeriod: values.agreementPeriod,
        };
        addTenantMutate(payload);
    };

    return (
        <Container style={{ height: `${height}px`, overflow: "auto" }}>
            <Header>
                <h1 className="text-white text-lg font-medium">Add Tenant</h1>
                <button
                    onClick={() => {
                        if (formikRef.current) formikRef.current.resetForm();
                        handleClose();
                    }}
                >
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <ProfileSection className="px-4 py-3 flex items-center justify-between">
                {/* Left: Icon + Info */}
                <div className="flex items-center gap-2">

                    {/* Inventory Icon */}
                    <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center">
                        <FaRegBuilding className="text-gray-600" />
                    </div>

                    {/* Text Info */}
                    <div className="flex flex-col">
                        <p className="text-md font-medium text-gray-800">
                            {selectedData?.inventoryName}
                        </p>
                        <p className="text-xs text-gray-400">
                            {selectedData?.address}
                        </p>
                    </div>

                </div>

                {/* Right: Budget */}
                {/* <div className="text-right">
                    <p className="text-xs text-gray-400">Budget</p>
                    <p className="text-lg font-bold text-green-600">
                        ₹{selectedData?.budget || 0}
                    </p>
                </div> */}
            </ProfileSection>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}
                >
                    {({
                        values,
                        setFieldValue,
                        handleChange,
                        handleBlur,
                        errors,
                        touched,
                        resetForm,
                    }) => {

                        const getScheduleLabel = () => {
                            const selected = rentScheduleOptions.find(r => r.value === values.rentSchedule);
                            return selected ? selected.label : "Select Rent Schedule";
                        };

                        return (
                            <Form autoComplete="off">
                                <ScrollableContent className="max-h-[calc(100vh-180px)]">
                                    <Wrapper>

                                        {/* Tenant Name */}
                                        <InputGroup>
                                            <Label>Tenant Name *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    name="tenant_name"
                                                    placeholder="Enter tenant name"
                                                    className="w-full"
                                                    autoComplete="off"
                                                />
                                            </FieldWrappers>
                                            {touched.tenant_name && errors.tenant_name && <ErrorText>{errors.tenant_name}</ErrorText>}
                                        </InputGroup>

                                        {/* Mobile */}
                                        <InputGroup>
                                            <Label>Mobile Number *</Label>
                                            <FieldWrappers>
                                                <MobileIcon />
                                                <Field
                                                    name="mobile"
                                                    className="pl-5 w-full"
                                                    maxLength={10}
                                                    placeholder="Enter tenant mobile"
                                                    autoComplete="off"
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (/^\d{0,10}$/.test(val)) {
                                                            setFieldValue("mobile", val);
                                                        }
                                                    }}
                                                />
                                            </FieldWrappers>
                                            {touched.mobile && errors.mobile && <ErrorText>{errors.mobile}</ErrorText>}
                                        </InputGroup>

                                        {/* Email */}
                                        <InputGroup>
                                            <Label>Email (Optional)</Label>
                                            <FieldWrappers>
                                                <Field name="tenant_email"
                                                    autoComplete="off"
                                                    placeholder="Enter tenant email"
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                        <CombineInputGroup>
                                            <InputGroup>
                                                <Label>Monthly Rent *</Label>
                                                <FieldWrappers>
                                                    <RupeeIcon />
                                                    <Field
                                                        type="number"
                                                        name="monthlyRent"
                                                        className="pl-5 w-full"
                                                        placeholder="Enter rent"
                                                    />
                                                </FieldWrappers>
                                                {touched.monthlyRent && errors.monthlyRent && <ErrorText>{errors.monthlyRent}</ErrorText>}
                                            </InputGroup>

                                            <InputGroup>
                                                <Label>Owner Rent (₹) *</Label>
                                                <FieldWrappers>
                                                    <RupeeIcon />
                                                    <Field
                                                        type="number"
                                                        name="ownerPayout"
                                                        className="pl-5 w-full"
                                                        placeholder="Enter owner rent"
                                                    />
                                                </FieldWrappers>
                                                {touched.ownerPayout && errors.ownerPayout && (
                                                    <ErrorText>{errors.ownerPayout}</ErrorText>
                                                )}
                                            </InputGroup>
                                        </CombineInputGroup>
                                        {/* Auto Margin */}
                                        <div className="bg-white border rounded-lg p-3 text-sm">
                                            <span className="text-gray-500">Your Margin</span>
                                            <p className="text-green-600 font-semibold">
                                                ₹ {(values.monthlyRent || 0) - (values.ownerPayout || 0)}
                                            </p>
                                        </div>
                                        {/* <InputGroup>
                                            <Label>Margin (₹)</Label>
                                            <FieldWrappers>
                                                <RupeeIcon />
                                                <input
                                                    type="number"
                                                    value={
                                                        (values.monthlyRent || 0) - (values.ownerRent || 0)
                                                    }
                                                    readOnly
                                                    className="pl-5 w-full bg-gray-50"
                                                />
                                            </FieldWrappers>
                                        </InputGroup> */}

                                        <InputGroup>
                                            <Label>Security Deposit *</Label>
                                            <FieldWrappers>
                                                <RupeeIcon />
                                                <Field
                                                    type="number"
                                                    name="securityDeposit"
                                                    className="pl-5 w-full"
                                                    placeholder="Enter rent"
                                                />
                                            </FieldWrappers>
                                            {touched.securityDeposit && errors.securityDeposit && <ErrorText>{errors.securityDeposit}</ErrorText>}
                                        </InputGroup>

                                        {/* Next Due Date */}
                                        <InputGroup>
                                            <Label>Due Date *</Label>
                                            <FieldWrappers>
                                                <DatePicker
                                                    selected={values.nextDueDate}
                                                    onChange={(d) => setFieldValue("nextDueDate", d)}
                                                    dateFormat="yyyy-MM-dd"
                                                    placeholderText="Select date"
                                                    className="cursor-pointer items-center"

                                                    showIcon
                                                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                />
                                            </FieldWrappers>
                                            {touched.nextDueDate && errors.nextDueDate && <ErrorText>{errors.nextDueDate}</ErrorText>}
                                        </InputGroup>

                                        {/* Upcoming Payments */}
                                        <InputGroup>
                                            <Label>No. of Upcoming Rent Payments *</Label>
                                            <FieldWrappers>
                                                <Field type="number" name="agreementPeriod" placeholder="Enter months" />
                                            </FieldWrappers>
                                            {touched.agreementPeriod && errors.agreementPeriod && <ErrorText>{errors.agreementPeriod}</ErrorText>}
                                        </InputGroup>

                                    </Wrapper>
                                </ScrollableContent>

                                <ActionSection>
                                    <SideCancelBtn type="button" onClick={() => { resetForm(); handleClose(); }}>
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit">
                                        {addTenantLoading ? "Submiting..." : "Submit"}
                                    </SubmitBtn>
                                </ActionSection>

                                <SelectOptionModal
                                    isOpen={isScheduleModalOpen}
                                    onClose={() => setIsScheduleModalOpen(false)}
                                    title="Select Rent Schedule"
                                    options={rentScheduleOptions}
                                    selectedValue={values.rentSchedule}
                                    onSelect={(val) => setFieldValue("rentSchedule", val)}
                                />
                            </Form>
                        )
                    }}
                </Formik>
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const ErrorText = tw.div`text-red-500 text-sm`;
const UserImageWrapper = tw.div`flex items-center gap-2`;

export default AddTenant;